export const state = () => ({
    inProcessStep:'',
    yotiIframeUrl:'',
    QRCode: '',
    sessionToken: '',
    useComputer: false,
    selectPerson:''
  })
